<template>
  <div class="w-full h-screen flex flex-col overflow-hidden justify-center items-center relative papsi-loading-screen">
      <img class="papsi-mascot w-1/6 mb-10" :src="getImage('kalabaw')" />
      <div class="text-primary text-5xl font-bold mb-10 flex items-center">
          <p class="uppercase">{{ $t('load01') }}</p>
          <span class="dots-container">
              <span class="dots"></span>
          </span>
      </div>
      <p class="text-grey-darker text-3xl w-1/2 text-center">{{ currentTrivia }}</p>
  </div>
</template>

<script>
import mixin from '@/mixins/controls.js';
import { trivia } from '@/assets/data/trivia.js';

export default {
  name: 'v-load',
  mixins: [mixin],
  data() {
      return {
          image: '',
          trivia,
          current_trivia_index: 0,
          trivia_interval: null
      };
  },
  computed: {
      currentTrivia() {
          return this.trivia[this.$i18n.locale][this.current_trivia_index];
      }
  },
  mounted() {
      this.image = this.getMediaPath('/logo/image_title.jpg');

      this.trivia_interval = setInterval(() => {
          this.current_trivia_index = Math.floor(Math.random() * this.trivia[this.$i18n.locale].length);
      }, 5000);
  },
  beforeUnmount() {
      clearInterval(this.trivia_interval);
  }
};
</script>

<style scoped>
  .papsi-loading-screen {
    background: radial-gradient(circle, 
                rgba(229, 231, 235, 1) 10%, 
                rgb(149, 155, 167) 100%);
  }

  @keyframes mascot-wave {
    0%, 100% { 
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
  }

  .papsi-mascot {
    animation: mascot-wave 1s ease-in-out infinite;
    transform-origin: top center;
  }

  .dots-container {
    display: inline-block;
    width: 2em;
    text-align: left;
  }

  @keyframes dot-blink {
    0% { content: ""; }
    25% { content: "."; }
    50% { content: ".."; }
    75% { content: "..."; }
    100% { content: ""; }
  }

  .dots::after {
    animation: dot-blink 2s steps(4, end) infinite;
    content: ""; /* Initial state */
  }
</style>